import { CalendarDays } from "lucide-react";
import Seo from "@/components/Seo";
import { DEFAULT_DESCRIPTION, DEFAULT_PAGE_TITLE } from "@/lib/site-config";
import Header from "@/components/landing/Header";
import HeroSection from "@/components/landing/HeroSection";
import ProblemSolutionSection from "@/components/ProblemSolutionSection";
import BentoSection from "@/components/landing/BentoSection";
import StepsSection from "@/components/landing/StepsSection";
import FinancialsSection from "@/components/landing/FinancialsSection";
import SecuritySection from "@/components/landing/SecuritySection";
import PricingSection from "@/components/landing/PricingSection";
import FAQSection from "@/components/landing/FAQSection";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";
import { faqItems } from "@/data/faq";

// Nota: el schema SoftwareApplication/Organization de "EkklesiaOnline" vive en
// public/index.html (estático). Aquí solo dejamos el FAQPage para no duplicar
// entidades ni reintroducir la marca antigua "Ekklesia" en el JSON-LD de runtime.
const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  },
];

export default function LandingPage() {
  return (
    <div className="w-full overflow-x-hidden bg-white text-ink">
      <Seo
        title={DEFAULT_PAGE_TITLE}
        description={DEFAULT_DESCRIPTION}
        path="/"
        jsonLd={homeJsonLd}
      />
      <Header />
      <HeroSection />
      <ProblemSolutionSection />
      <BentoSection />
      <StepsSection />

      {/* Mini sección "¿Tienes dudas?" — solo visible en móvil (oculto en ≥768px),
          justo debajo de "Empieza en tres pasos". Abre el popup de Cal.com. */}
      <div className="block px-6 py-10 text-center md:hidden" style={{ backgroundColor: "#EDE9FE" }} data-testid="steps-mobile-cta">
        <h2
          className="font-display tracking-tight text-ink"
          style={{ fontSize: "1.875rem", fontWeight: "700", lineHeight: "1.2" }}
        >
          ¿Tienes dudas sobre cómo funciona?
        </h2>
        <p
          className="mx-auto mt-3 max-w-md text-ink-2"
          style={{ fontSize: "1rem", lineHeight: "1.6" }}
        >
          Agenda una llamada de 45 minutos con nosotros y te explicamos cómo
          EkklesiaOnline puede ayudar a la iglesia. Sin compromiso.
        </p>
        <button
          type="button"
          data-cal-link="ekklesiaonline-demo"
          data-cal-config='{"layout":"month_view"}'
          data-testid="steps-mobile-agenda"
          className="mt-6 inline-flex h-[52px] w-full max-w-sm items-center justify-center gap-2 rounded-xl bg-violet-fuerte px-8 text-[17px] font-semibold text-white shadow-[0_6px_24px_-6px_rgba(74,58,138,0.45)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-violet-oscuro hover:shadow-[0_10px_32px_-6px_rgba(74,58,138,0.5)]"
        >
          <CalendarDays className="h-5 w-5" />
          Agenda una llamada
        </button>
      </div>

      <FinancialsSection />
      <SecuritySection />
      <PricingSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
